import { asLink, asImageSrc } from "@prismicio/helpers";
import { linkResolver } from "~/lib/prismic/utils";
import type { SliceComponentProps } from "@prismicio/react";
import type { HeroBannerSlice } from "prismicio-types";

const HeroBanner = ({ slice }: SliceComponentProps<HeroBannerSlice>) => {
  const imgixParams = { q: 85, auto: "format", sharp: 10 };

  const desktopUrl = asImageSrc(slice.primary.image, imgixParams);

  if (!desktopUrl) {
    return null;
  }

  const mobileUrl = asImageSrc(slice.primary.image.mobile, imgixParams) || desktopUrl;
  const altText = slice.primary.image.alt || "";

  const picture = (
    <picture>
      <source media="(max-width: 767px)" srcSet={mobileUrl} />
      <source media="(min-width: 768px)" srcSet={desktopUrl} />
      <img src={desktopUrl} alt={altText} />
    </picture>
  );

  return (
    <div className="container px-0 px-lg-3">
      <div className="mb-3 component-visual-text">
        <div className="component-visual-text__bg">
          {slice.primary.has_link ? (
            <a
              href={asLink(slice.primary.link, linkResolver) || ""}
              target={slice.primary.newWindow ? "_blank" : ""}
              rel="noopener noreferrer"
            >
              {picture}
            </a>
          ) : (
            picture
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;